import axios from '../utils/axios';

export default function fetchProductTypes(adminId) {
    
    return (
        axios.get('/admin/' + adminId + '/manageSeekerSubscriptions/subscription/admin/all-plans')
        .then(response => {
            return response.data;
        })
    )
}
